// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --buttonLargeWidth: 3rem;
}

.button {
  display: inline-block;
  padding: calc(.5rem) calc(1.25rem);

  font-weight: 700;
  vertical-align: middle;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  -webkit-text-decoration: none;
  text-decoration: none;
  appearance: none;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 0.25rem;
  transition: background-color 200ms ease;

  font-size: 1rem;

  line-height: 1.5rem;

  color: #fff;

  background-color: #206dd2;

  border: 0.0625rem solid #206dd2;
}

.button.button--backward::before {
    border-right-color: #fff;
  }

.button.button--text.button--backward::before {
    border-right-color: #206dd2;
  }

.button.button--forward::after {
    border-left-color: #fff;
  }

.button.button--text.button--forward::after {
    border-left-color: #206dd2;
  }

.button:hover,
  .button.hover {
    color: #fff;
    background-color: #00429d;
  }

.button:hover.button--backward::before, .button.hover.button--backward::before {
    border-right-color: #fff;
  }

.button:hover.button--text.button--backward::before, .button.hover.button--text.button--backward::before {
    border-right-color: #00429d;
  }

.button:hover.button--forward::after, .button.hover.button--forward::after {
    border-left-color: #fff;
  }

.button:hover.button--text.button--forward::after, .button.hover.button--text.button--forward::after {
    border-left-color: #00429d;
  }

.button:active,
  .button.active {
    color: #fff;
    background-color: #00254d;
  }

.button:active.button--backward::before, .button.active.button--backward::before {
    border-right-color: #fff;
  }

.button:active.button--text.button--backward::before, .button.active.button--text.button--backward::before {
    border-right-color: #00254d;
  }

.button:active.button--forward::after, .button.active.button--forward::after {
    border-left-color: #fff;
  }

.button:active.button--text.button--forward::after, .button.active.button--text.button--forward::after {
    border-left-color: #00254d;
  }

.button.button--submitting,
  .button.button--submitting:disabled {
    color: #fff;
    background-color: #00254d;
  }

.button.button--submitting.button--backward::before, .button.button--submitting:disabled.button--backward::before {
    border-right-color: #fff;
  }

.button.button--submitting.button--text.button--backward::before, .button.button--submitting:disabled.button--text.button--backward::before {
    border-right-color: #00254d;
  }

.button.button--submitting.button--forward::after, .button.button--submitting:disabled.button--forward::after {
    border-left-color: #fff;
  }

.button.button--submitting.button--text.button--forward::after, .button.button--submitting:disabled.button--text.button--forward::after {
    border-left-color: #00254d;
  }

.button--primary:focus-visible:not(.button--icon) {
        margin: 0.0625rem;
        outline: 2px solid #206dd2;
        outline-offset: 2px;
        border: none;
      }

.button.button--text {
    color: #206dd2;
    border: 0;
  }

.button.button--text:hover,
  .button.button--text:active {
    color: #00429d;
  }

.button.button--inline-text {
    color: #206dd2;
    border: 0;
  }

.button.button--inline-text:hover,
  .button.button--inline-text:active {
    color: #00429d;
  }

.button--full-width {
    width: 100%;
  }

.button--full-width-mobile {
    width: 100%;
  }

@media (width > 640px) {

.button--full-width-mobile {
      width: auto
  }
    }

.button--flex-layout {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

.button--large {
    padding: calc(.75rem) 1rem;
  }

.button--small {
    font-size: 0.875rem;
    line-height: 1.375rem;
  }

.button--extra-small {
    padding: calc(.25rem) calc(.75rem);
  }

.button--text {
    padding-right: 0;
    padding-left: 0;
    background-color: transparent !important;
  }

.button--text:disabled {
      color: #d4d4d4 !important;
    }

.button--inline-text {
    padding: 0;
    text-transform: none;
    background-color: transparent !important;
  }

.button--inline-text:disabled {
      color: #d4d4d4 !important;
    }

.button--icon {
    width: 2.25rem;
    padding-top: 0;
    padding-bottom: 0;
    color: #206dd2;
  }

.button--icon--auto-width {
      width: auto;
    }

.button--icon.button--large {
      width: 3rem;
    }

.button--icon.button--small {
      width: 2rem;
    }

.button--secondary {
    color: #206dd2;
    background-color: #fff;
    border: 0.0625rem solid #206dd2;
  }

.button--secondary.button--backward::before {
    border-right-color: #206dd2;
  }

.button--secondary.button--text.button--backward::before {
    border-right-color: #fff;
  }

.button--secondary.button--forward::after {
    border-left-color: #206dd2;
  }

.button--secondary.button--text.button--forward::after {
    border-left-color: #fff;
  }

.button--secondary:hover,
  .button--secondary.hover {
    color: #206dd2;
    background-color: #e5f5ff;
  }

.button--secondary:hover.button--backward::before, .button--secondary.hover.button--backward::before {
    border-right-color: #206dd2;
  }

.button--secondary:hover.button--text.button--backward::before, .button--secondary.hover.button--text.button--backward::before {
    border-right-color: #e5f5ff;
  }

.button--secondary:hover.button--forward::after, .button--secondary.hover.button--forward::after {
    border-left-color: #206dd2;
  }

.button--secondary:hover.button--text.button--forward::after, .button--secondary.hover.button--text.button--forward::after {
    border-left-color: #e5f5ff;
  }

.button--secondary:active,
  .button--secondary.active {
    color: #fff;
    background-color: #206dd2;
  }

.button--secondary:active.button--backward::before, .button--secondary.active.button--backward::before {
    border-right-color: #fff;
  }

.button--secondary:active.button--text.button--backward::before, .button--secondary.active.button--text.button--backward::before {
    border-right-color: #206dd2;
  }

.button--secondary:active.button--forward::after, .button--secondary.active.button--forward::after {
    border-left-color: #fff;
  }

.button--secondary:active.button--text.button--forward::after, .button--secondary.active.button--text.button--forward::after {
    border-left-color: #206dd2;
  }

.button--secondary.button--submitting,
  .button--secondary.button--submitting:disabled {
    color: #fff;
    background-color: #00429d;
  }

.button--secondary.button--submitting.button--backward::before, .button--secondary.button--submitting:disabled.button--backward::before {
    border-right-color: #fff;
  }

.button--secondary.button--submitting.button--text.button--backward::before, .button--secondary.button--submitting:disabled.button--text.button--backward::before {
    border-right-color: #00429d;
  }

.button--secondary.button--submitting.button--forward::after, .button--secondary.button--submitting:disabled.button--forward::after {
    border-left-color: #fff;
  }

.button--secondary.button--submitting.button--text.button--forward::after, .button--secondary.button--submitting:disabled.button--text.button--forward::after {
    border-left-color: #00429d;
  }

.button--destructive {
    color: #fff;
    background-color: #dd201d;
    border: none;
  }

.button--destructive.button--backward::before {
    border-right-color: #fff;
  }

.button--destructive.button--text.button--backward::before {
    border-right-color: #dd201d;
  }

.button--destructive.button--forward::after {
    border-left-color: #fff;
  }

.button--destructive.button--text.button--forward::after {
    border-left-color: #dd201d;
  }

.button--destructive:hover,
  .button--destructive.hover {
    color: #fff;
    background-color: #8b1715;
  }

.button--destructive:hover.button--backward::before, .button--destructive.hover.button--backward::before {
    border-right-color: #fff;
  }

.button--destructive:hover.button--text.button--backward::before, .button--destructive.hover.button--text.button--backward::before {
    border-right-color: #8b1715;
  }

.button--destructive:hover.button--forward::after, .button--destructive.hover.button--forward::after {
    border-left-color: #fff;
  }

.button--destructive:hover.button--text.button--forward::after, .button--destructive.hover.button--text.button--forward::after {
    border-left-color: #8b1715;
  }

.button--destructive:active,
  .button--destructive.active {
    color: #fff;
    background-color: #420e0d;
  }

.button--destructive:active.button--backward::before, .button--destructive.active.button--backward::before {
    border-right-color: #fff;
  }

.button--destructive:active.button--text.button--backward::before, .button--destructive.active.button--text.button--backward::before {
    border-right-color: #420e0d;
  }

.button--destructive:active.button--forward::after, .button--destructive.active.button--forward::after {
    border-left-color: #fff;
  }

.button--destructive:active.button--text.button--forward::after, .button--destructive.active.button--text.button--forward::after {
    border-left-color: #420e0d;
  }

.button--destructive.button--submitting,
  .button--destructive.button--submitting:disabled {
    color: #fff;
    background-color: #420e0d;
  }

.button--destructive.button--submitting.button--backward::before, .button--destructive.button--submitting:disabled.button--backward::before {
    border-right-color: #fff;
  }

.button--destructive.button--submitting.button--text.button--backward::before, .button--destructive.button--submitting:disabled.button--text.button--backward::before {
    border-right-color: #420e0d;
  }

.button--destructive.button--submitting.button--forward::after, .button--destructive.button--submitting:disabled.button--forward::after {
    border-left-color: #fff;
  }

.button--destructive.button--submitting.button--text.button--forward::after, .button--destructive.button--submitting:disabled.button--text.button--forward::after {
    border-left-color: #420e0d;
  }

.button--destructive.button--text {
      color: #dd201d;
      border: 0;
    }

.button--destructive.button--text:hover,
  .button--destructive.button--text:active {
    color: #8b1715;
  }

.button--destructive.button--inline-text {
      color: #dd201d;
      border: 0;
    }

.button--destructive.button--inline-text:hover,
  .button--destructive.button--inline-text:active {
    color: #8b1715;
  }

.button--destructiveSecondary {
    color: #dd201d;
    background-color: #fff;
    border: 0.0625rem solid #dd201d;
  }

.button--destructiveSecondary.button--backward::before {
    border-right-color: #dd201d;
  }

.button--destructiveSecondary.button--text.button--backward::before {
    border-right-color: #fff;
  }

.button--destructiveSecondary.button--forward::after {
    border-left-color: #dd201d;
  }

.button--destructiveSecondary.button--text.button--forward::after {
    border-left-color: #fff;
  }

.button--destructiveSecondary:hover,
  .button--destructiveSecondary.hover {
    color: #dd201d;
    background-color: #fde4e3;
  }

.button--destructiveSecondary:hover.button--backward::before, .button--destructiveSecondary.hover.button--backward::before {
    border-right-color: #dd201d;
  }

.button--destructiveSecondary:hover.button--text.button--backward::before, .button--destructiveSecondary.hover.button--text.button--backward::before {
    border-right-color: #fde4e3;
  }

.button--destructiveSecondary:hover.button--forward::after, .button--destructiveSecondary.hover.button--forward::after {
    border-left-color: #dd201d;
  }

.button--destructiveSecondary:hover.button--text.button--forward::after, .button--destructiveSecondary.hover.button--text.button--forward::after {
    border-left-color: #fde4e3;
  }

.button--destructiveSecondary:active,
  .button--destructiveSecondary.active {
    color: #fff;
    background-color: #bf322e;
  }

.button--destructiveSecondary:active.button--backward::before, .button--destructiveSecondary.active.button--backward::before {
    border-right-color: #fff;
  }

.button--destructiveSecondary:active.button--text.button--backward::before, .button--destructiveSecondary.active.button--text.button--backward::before {
    border-right-color: #bf322e;
  }

.button--destructiveSecondary:active.button--forward::after, .button--destructiveSecondary.active.button--forward::after {
    border-left-color: #fff;
  }

.button--destructiveSecondary:active.button--text.button--forward::after, .button--destructiveSecondary.active.button--text.button--forward::after {
    border-left-color: #bf322e;
  }

.button--destructiveSecondary.button--submitting,
  .button--destructiveSecondary.button--submitting:disabled {
    color: #fff;
    background-color: #dd201d;
  }

.button--destructiveSecondary.button--submitting.button--backward::before, .button--destructiveSecondary.button--submitting:disabled.button--backward::before {
    border-right-color: #fff;
  }

.button--destructiveSecondary.button--submitting.button--text.button--backward::before, .button--destructiveSecondary.button--submitting:disabled.button--text.button--backward::before {
    border-right-color: #dd201d;
  }

.button--destructiveSecondary.button--submitting.button--forward::after, .button--destructiveSecondary.button--submitting:disabled.button--forward::after {
    border-left-color: #fff;
  }

.button--destructiveSecondary.button--submitting.button--text.button--forward::after, .button--destructiveSecondary.button--submitting:disabled.button--text.button--forward::after {
    border-left-color: #dd201d;
  }

.button--destructiveSecondary.button--text {
      color: #dd201d;
      border: 0;
    }

.button--destructiveSecondary.button--text:hover,
  .button--destructiveSecondary.button--text:active {
    color: #bf322e;
  }

.button--destructiveSecondary.button--inline-text {
      color: #dd201d;
      border: 0;
    }

.button--destructiveSecondary.button--inline-text:hover,
  .button--destructiveSecondary.button--inline-text:active {
    color: #bf322e;
  }

.button--destructiveSecondaryWhite {
    color: #dd201d;
    background-color: #fff;
    border: 0.0625rem solid #e5e6e6;
  }

.button--destructiveSecondaryWhite.button--backward::before {
    border-right-color: #dd201d;
  }

.button--destructiveSecondaryWhite.button--text.button--backward::before {
    border-right-color: #fff;
  }

.button--destructiveSecondaryWhite.button--forward::after {
    border-left-color: #dd201d;
  }

.button--destructiveSecondaryWhite.button--text.button--forward::after {
    border-left-color: #fff;
  }

.button--destructiveSecondaryWhite:hover,
  .button--destructiveSecondaryWhite.hover {
    color: #dd201d;
    background-color: #fde4e3;
  }

.button--destructiveSecondaryWhite:hover.button--backward::before, .button--destructiveSecondaryWhite.hover.button--backward::before {
    border-right-color: #dd201d;
  }

.button--destructiveSecondaryWhite:hover.button--text.button--backward::before, .button--destructiveSecondaryWhite.hover.button--text.button--backward::before {
    border-right-color: #fde4e3;
  }

.button--destructiveSecondaryWhite:hover.button--forward::after, .button--destructiveSecondaryWhite.hover.button--forward::after {
    border-left-color: #dd201d;
  }

.button--destructiveSecondaryWhite:hover.button--text.button--forward::after, .button--destructiveSecondaryWhite.hover.button--text.button--forward::after {
    border-left-color: #fde4e3;
  }

.button--destructiveSecondaryWhite:active,
  .button--destructiveSecondaryWhite.active {
    color: #fff;
    background-color: #bf322e;
  }

.button--destructiveSecondaryWhite:active.button--backward::before, .button--destructiveSecondaryWhite.active.button--backward::before {
    border-right-color: #fff;
  }

.button--destructiveSecondaryWhite:active.button--text.button--backward::before, .button--destructiveSecondaryWhite.active.button--text.button--backward::before {
    border-right-color: #bf322e;
  }

.button--destructiveSecondaryWhite:active.button--forward::after, .button--destructiveSecondaryWhite.active.button--forward::after {
    border-left-color: #fff;
  }

.button--destructiveSecondaryWhite:active.button--text.button--forward::after, .button--destructiveSecondaryWhite.active.button--text.button--forward::after {
    border-left-color: #bf322e;
  }

.button--destructiveSecondaryWhite.button--submitting,
  .button--destructiveSecondaryWhite.button--submitting:disabled {
    color: #fff;
    background-color: #dd201d;
  }

.button--destructiveSecondaryWhite.button--submitting.button--backward::before, .button--destructiveSecondaryWhite.button--submitting:disabled.button--backward::before {
    border-right-color: #fff;
  }

.button--destructiveSecondaryWhite.button--submitting.button--text.button--backward::before, .button--destructiveSecondaryWhite.button--submitting:disabled.button--text.button--backward::before {
    border-right-color: #dd201d;
  }

.button--destructiveSecondaryWhite.button--submitting.button--forward::after, .button--destructiveSecondaryWhite.button--submitting:disabled.button--forward::after {
    border-left-color: #fff;
  }

.button--destructiveSecondaryWhite.button--submitting.button--text.button--forward::after, .button--destructiveSecondaryWhite.button--submitting:disabled.button--text.button--forward::after {
    border-left-color: #dd201d;
  }

.button--destructiveSecondaryWhite.button--text {
      color: #dd201d;
      border: 0;
    }

.button--destructiveSecondaryWhite.button--text:hover,
  .button--destructiveSecondaryWhite.button--text:active {
    color: #bf322e;
  }

.button--destructiveSecondaryWhite.button--inline-text {
      color: #dd201d;
      border: 0;
    }

.button--destructiveSecondaryWhite.button--inline-text:hover,
  .button--destructiveSecondaryWhite.button--inline-text:active {
    color: #bf322e;
  }

.button--danger {
    color: #dd201d;
    background-color: #fff;
    border: 0.0625rem solid #dd201d;
  }

.button--danger.button--backward::before {
    border-right-color: #dd201d;
  }

.button--danger.button--text.button--backward::before {
    border-right-color: #fff;
  }

.button--danger.button--forward::after {
    border-left-color: #dd201d;
  }

.button--danger.button--text.button--forward::after {
    border-left-color: #fff;
  }

.button--danger:hover,
  .button--danger.hover {
    color: #dd201d;
    background-color: #fde4e3;
  }

.button--danger:hover.button--backward::before, .button--danger.hover.button--backward::before {
    border-right-color: #dd201d;
  }

.button--danger:hover.button--text.button--backward::before, .button--danger.hover.button--text.button--backward::before {
    border-right-color: #fde4e3;
  }

.button--danger:hover.button--forward::after, .button--danger.hover.button--forward::after {
    border-left-color: #dd201d;
  }

.button--danger:hover.button--text.button--forward::after, .button--danger.hover.button--text.button--forward::after {
    border-left-color: #fde4e3;
  }

.button--danger:active,
  .button--danger.active {
    color: #fff;
    background-color: #bf322e;
  }

.button--danger:active.button--backward::before, .button--danger.active.button--backward::before {
    border-right-color: #fff;
  }

.button--danger:active.button--text.button--backward::before, .button--danger.active.button--text.button--backward::before {
    border-right-color: #bf322e;
  }

.button--danger:active.button--forward::after, .button--danger.active.button--forward::after {
    border-left-color: #fff;
  }

.button--danger:active.button--text.button--forward::after, .button--danger.active.button--text.button--forward::after {
    border-left-color: #bf322e;
  }

.button--danger.button--submitting,
  .button--danger.button--submitting:disabled {
    color: #fff;
    background-color: #dd201d;
  }

.button--danger.button--submitting.button--backward::before, .button--danger.button--submitting:disabled.button--backward::before {
    border-right-color: #fff;
  }

.button--danger.button--submitting.button--text.button--backward::before, .button--danger.button--submitting:disabled.button--text.button--backward::before {
    border-right-color: #dd201d;
  }

.button--danger.button--submitting.button--forward::after, .button--danger.button--submitting:disabled.button--forward::after {
    border-left-color: #fff;
  }

.button--danger.button--submitting.button--text.button--forward::after, .button--danger.button--submitting:disabled.button--text.button--forward::after {
    border-left-color: #dd201d;
  }

.button--danger.button--text {
      color: #dd201d;
      border: 0;
    }

.button--danger.button--text:hover,
  .button--danger.button--text:active {
    color: #bf322e;
  }

.button--danger.button--inline-text {
      color: #dd201d;
      border: 0;
    }

.button--danger.button--inline-text:hover,
  .button--danger.button--inline-text:active {
    color: #bf322e;
  }

.button--grey {
    color: #fff;
    background-color: #d4d4d4;
    border: 0.0625rem solid #d4d4d4;
  }

.button--grey.button--backward::before {
    border-right-color: #fff;
  }

.button--grey.button--text.button--backward::before {
    border-right-color: #d4d4d4;
  }

.button--grey.button--forward::after {
    border-left-color: #fff;
  }

.button--grey.button--text.button--forward::after {
    border-left-color: #d4d4d4;
  }

.button--grey:hover,
  .button--grey.hover {
    color: #fff;
    background-color: #707070;
  }

.button--grey:hover.button--backward::before, .button--grey.hover.button--backward::before {
    border-right-color: #fff;
  }

.button--grey:hover.button--text.button--backward::before, .button--grey.hover.button--text.button--backward::before {
    border-right-color: #707070;
  }

.button--grey:hover.button--forward::after, .button--grey.hover.button--forward::after {
    border-left-color: #fff;
  }

.button--grey:hover.button--text.button--forward::after, .button--grey.hover.button--text.button--forward::after {
    border-left-color: #707070;
  }

.button--grey:active,
  .button--grey.active {
    color: #fff;
    background-color: #707070;
  }

.button--grey:active.button--backward::before, .button--grey.active.button--backward::before {
    border-right-color: #fff;
  }

.button--grey:active.button--text.button--backward::before, .button--grey.active.button--text.button--backward::before {
    border-right-color: #707070;
  }

.button--grey:active.button--forward::after, .button--grey.active.button--forward::after {
    border-left-color: #fff;
  }

.button--grey:active.button--text.button--forward::after, .button--grey.active.button--text.button--forward::after {
    border-left-color: #707070;
  }

.button--grey.button--submitting,
  .button--grey.button--submitting:disabled {
    color: #fff;
    background-color: #707070;
  }

.button--grey.button--submitting.button--backward::before, .button--grey.button--submitting:disabled.button--backward::before {
    border-right-color: #fff;
  }

.button--grey.button--submitting.button--text.button--backward::before, .button--grey.button--submitting:disabled.button--text.button--backward::before {
    border-right-color: #707070;
  }

.button--grey.button--submitting.button--forward::after, .button--grey.button--submitting:disabled.button--forward::after {
    border-left-color: #fff;
  }

.button--grey.button--submitting.button--text.button--forward::after, .button--grey.button--submitting:disabled.button--text.button--forward::after {
    border-left-color: #707070;
  }

.button--grey.button--text {
      color: #424242;
      border: 0;
    }

.button--grey.button--text:hover,
  .button--grey.button--text:active {
    color: #282828;
  }

.button--grey.button--inline-text {
      color: #424242;
      border: 0;
    }

.button--grey.button--inline-text:hover,
  .button--grey.button--inline-text:active {
    color: #282828;
  }

.button--white {
    color: #424242;
    background-color: #fff;
    border: 0.0625rem solid #e5e6e6;
  }

.button--white.button--backward::before {
    border-right-color: #424242;
  }

.button--white.button--text.button--backward::before {
    border-right-color: #fff;
  }

.button--white.button--forward::after {
    border-left-color: #424242;
  }

.button--white.button--text.button--forward::after {
    border-left-color: #fff;
  }

.button--white:hover,
  .button--white.hover {
    color: #424242;
    background-color: #f6f7f8;
  }

.button--white:hover.button--backward::before, .button--white.hover.button--backward::before {
    border-right-color: #424242;
  }

.button--white:hover.button--text.button--backward::before, .button--white.hover.button--text.button--backward::before {
    border-right-color: #f6f7f8;
  }

.button--white:hover.button--forward::after, .button--white.hover.button--forward::after {
    border-left-color: #424242;
  }

.button--white:hover.button--text.button--forward::after, .button--white.hover.button--text.button--forward::after {
    border-left-color: #f6f7f8;
  }

.button--white:active,
  .button--white.active {
    color: #424242;
    background-color: #f6f7f8;
  }

.button--white:active.button--backward::before, .button--white.active.button--backward::before {
    border-right-color: #424242;
  }

.button--white:active.button--text.button--backward::before, .button--white.active.button--text.button--backward::before {
    border-right-color: #f6f7f8;
  }

.button--white:active.button--forward::after, .button--white.active.button--forward::after {
    border-left-color: #424242;
  }

.button--white:active.button--text.button--forward::after, .button--white.active.button--text.button--forward::after {
    border-left-color: #f6f7f8;
  }

.button--white.button--submitting,
  .button--white.button--submitting:disabled {
    color: #424242;
    background-color: #f6f7f8;
  }

.button--white.button--submitting.button--backward::before, .button--white.button--submitting:disabled.button--backward::before {
    border-right-color: #424242;
  }

.button--white.button--submitting.button--text.button--backward::before, .button--white.button--submitting:disabled.button--text.button--backward::before {
    border-right-color: #f6f7f8;
  }

.button--white.button--submitting.button--forward::after, .button--white.button--submitting:disabled.button--forward::after {
    border-left-color: #424242;
  }

.button--white.button--submitting.button--text.button--forward::after, .button--white.button--submitting:disabled.button--text.button--forward::after {
    border-left-color: #f6f7f8;
  }

.button--white.button--text {
      color: #424242;
      border: 0;
    }

.button--white.button--text:hover,
  .button--white.button--text:active {
    color: #282828;
  }

.button--white.button--inline-text {
      color: #424242;
      border: 0;
    }

.button--white.button--inline-text:hover,
  .button--white.button--inline-text:active {
    color: #282828;
  }

.button:disabled,
  .button:disabled:hover,
  .button:disabled:active,
  .button.disabled,
  .button.disabled:hover,
  .button.disabled:active {
    color: #424242;
    cursor: not-allowed;
    background-color: #d4d4d4;
    border: 1px solid #d4d4d4;
  }

.button:disabled.button--backward::before, .button:disabled:hover.button--backward::before, .button:disabled:active.button--backward::before, .button.disabled.button--backward::before, .button.disabled:hover.button--backward::before, .button.disabled:active.button--backward::before {
    border-right-color: #424242;
  }

.button:disabled.button--text.button--backward::before, .button:disabled:hover.button--text.button--backward::before, .button:disabled:active.button--text.button--backward::before, .button.disabled.button--text.button--backward::before, .button.disabled:hover.button--text.button--backward::before, .button.disabled:active.button--text.button--backward::before {
    border-right-color: #424242;
  }

.button:disabled.button--forward::after, .button:disabled:hover.button--forward::after, .button:disabled:active.button--forward::after, .button.disabled.button--forward::after, .button.disabled:hover.button--forward::after, .button.disabled:active.button--forward::after {
    border-left-color: #424242;
  }

.button:disabled.button--text.button--forward::after, .button:disabled:hover.button--text.button--forward::after, .button:disabled:active.button--text.button--forward::after, .button.disabled.button--text.button--forward::after, .button.disabled:hover.button--text.button--forward::after, .button.disabled:active.button--text.button--forward::after {
    border-left-color: #424242;
  }

.button--forward::after,
  .button--backward::before {
    display: inline-block;
    margin: 0 0.3rem;
    vertical-align: baseline;
    content: '';
    border: 0.35rem solid transparent;
  }

.button--forward::after {
    margin-right: 0;
    border-right: none;
  }

.button--backward::before {
    margin-left: 0;
    border-left: none;
  }

.button a.button--forward::after {
    margin-left: calc(.5rem);
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
